import type { AppRouteModule } from '/@/router/types';
import { useJobStore } from '/@/store/modules/job';

import { t } from '/@/hooks/web/useI18n';
import { LAYOUT } from '/@/router/constant';

const reference: AppRouteModule = {
  path: '/',
  name: 'Reference',
  component: LAYOUT,
  redirect: '/inspiration',
  meta: {
    hideChildrenInMenu: true,
    orderNo: 2,
    icon: 'icon-linggan',
    title: t('routes.create.references'),
    activePaths: ['/inspiration/*', '/generate/*'],
  },
  children: [
    {
      path: '/inspiration',
      name: 'inspiration',
      meta: {
        title: t('routes.create.references'),
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/inspiration/inspiration.vue'),
    },
    {
      path: '/generate',
      name: 'generate',
      meta: {
        title: '灵感生成',
        ignoreKeepAlive: false,
        scrollToTop: true,
      },
      beforeEnter: async (to, _, next) => {
        const { jobs, fetchJobs } = useJobStore();
        const { jobId, inspirationId, blank } = to.query;
        if (!jobId && !inspirationId && !blank) {
          await fetchJobs();
          if (jobs.length > 0) {
            next(`/generate?jobId=${jobs[0].id}`);
          } else {
            next(`/generate?blank=1`);
          }
        } else {
          next();
        }
      },
      component: () => import('/@/views/generate/index.vue'),
    },
    {
      path: '/creation',
      name: 'CreationTools',
      meta: {
        title: '创作',
        ignoreKeepAlive: false,
        hideMenu: true,
      },
      component: () => import('/@/views/creation/index.vue'),
    },
  ],
};

export default reference;
